/**
 * [getObjetIndexByKey Return the index of the first object that contain a key equal to a value in an array]
 * @param  {array} array [An array of objects]
 * @param  {string} key   [The key to test]
 * @param  {string} value [The value to test]
 * @return {number}       [The indexOf the first object matching the filter]
 */
export const getObjetIndexByKey = function (array: Array<{[index: string]: unknown}>, key: string, value: string): number {
    const object = array.filter(item => {
        if (typeof item === "object" && item !== null) {
            return item[key] === value;
        }

        return false;

    })[0];
    return array.indexOf(object);
};